/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BellZIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABrUlEQVR4nM2UzStEURTAH4rYULKgJCV7JaXsbIbe+Rh1nDMk69mRheUsWUjKP2Bnzcp/YCFlxUqT8jHCQtgo0X3zgfHmzcebhVNnc++7v985596e5/2XQDREsjtkzQErFdeB7AnZPn8mkH74pNP1wAeA9P4bojkRaQv2WB/KBYGE1a8K9n2/C1m3kO2tHFBeIZCtlPbJztzZSDjzUi+SnYZVV4Aclwrh1BSQvufX9TKZXOyvWj2wHlWEB3O2FfcdkQ5+j09zADJSC5wi4WxZdweJRKIDWE8K8GdEG6sKLwgOogV6kB+NzlTo7ila8OvFWJjgMBCQTrsnGfJMH6sJ/hzC34BbEen0Go0oOP7ogllH64a7ymoRYMhYaumqBUn3GhFg/nL3M5lMa0U6kK01Csdioq1Gzf4qrgDYshECfY0tIHupLCDbjT0ist3IW0a0cWDdBrLz2qF6AWQ7zKkJr54QkW6fU5OYnF8E1jSQrgfJmnZrbo9ouceLGwAynBDpcz+3IEX6ZucWhmKDSwLWm5DRXDdNgGybIa9lo2kCEWl3EtdJoZtNt9Y0QZz4AqtiAoP4RmKVAAAAAElFTkSuQmCC)
 */
export const BellZIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.07 3.29 18.68 7h2.82c.28 0 .5.23.5.5v1a.5.5 0 0 1-.5.5h-5.33a.5.5 0 0 1-.5-.5v-1a1 1 0 0 1 .21-.63l1.1-1.38 1.99-2.5H16.5a.5.5 0 0 1-.5-.5V1.5c0-.28.22-.5.5-.5h5.33c.28 0 .5.22.5.5v1.11a1 1 0 0 1-.26.68Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 11.5a.5.5 0 0 0-.5-.5h-2.33a2.5 2.5 0 0 1-2.5-2.5v-1a3 3 0 0 1 .65-1.87l.48-.6c.18-.23.12-.57-.08-.78a2.5 2.5 0 0 1-.7-1.49.94.94 0 0 0-.07-.24 2 2 0 0 0-3.87-.07.62.62 0 0 1-.39.44A7 7 0 0 0 5 9.5v2.09a.5.5 0 0 1-.13.33l-1.1 1.22A3 3 0 0 0 3 15.15v.28c0 .67.34 1.29.95 1.56 1.31.6 4 1.51 8.05 1.51 4.05 0 6.74-.91 8.05-1.5.61-.28.95-.9.95-1.57v-.28a3 3 0 0 0-.77-2l-1.1-1.23a.5.5 0 0 1-.13-.33v-.09ZM9.18 19.84A.16.16 0 0 0 9 20a3 3 0 1 0 6 0c0-.1-.09-.17-.18-.16a24.84 24.84 0 0 1-5.64 0Z"
        className={colorClass}
      />
    </svg>
  );
};
